export default {"src":"/_next/static/media/close.b2b502ed.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};